export const CHECKLIST_KEY_TO_LABEL_MAP: Record<string, string> = {
  departmentLeaders: "Department Leaders",
  teamLeaders: "Team Leaders",
  managers: "Managers",
  teamMembers: "Team Members",
  nonTeamMembers: "All Other Users (Non Team Members)",
  admin: "Admin",
};
